Base = App.loadClass 'core::Services/MapLayers/Base'
colorize = App.load 'public::geojson-colorize'

# Used to recalculate / display Rx Maps during the
# Planting Rx process.
exports.register = (module) ->
    module.factory 'Core.Services.MapLayers.PopulationMap', [
        # This is sorta annoying / hacky. Because this extends Base,
        # we have to be sure to inject all the same dependencies
        # as we did for Base. Which means if Base changes, we need
        # to update this list...
        '$http',
        'Core.Services.Map',
        '$q',
        '$rootScope',
        'PlantingRx.Services.PlantingRxService',
        'PlantingRx.Services.LegendService',
        (args..., $rootScope, rxLayer, legend) ->
            return {
                new: () ->
                    map = new exports.PopulationMap(args...)
                    map.rootScope = $rootScope
                    map.rxLayer = rxLayer
                    map.legend = legend
                    return map
            }

    ]


class exports.PopulationMap extends Base
    url: 'backend/grower/layers/planting-rx/populations'

    getGeoJSON: (response) =>
        if response?.data?.status?.type is 'success'
            return response.data.data.layer

    # Update the color of the rx layer
    recolor: () =>
        return if not @geojson?

        json = @geojson.toGeoJSON()
        json = @legend.update(json, 'population')

        @hide(@layer_added_to)
        @makeMapLayer(@layer_added_to, json)

    propertyTable: (ft, layer) =>

        layer.on 'click', (e) =>
            layer.unbindPopup()

            if ft.properties?
                props = ft.properties
                info = "
                    <div class='planting-rx population-popup'>
                        <table class='table table-condensed margin-top-22'>
                "

                if props.display_id
                    info += @_property('ID', props.display_id)

                info += @_property 'Brand', props.hybrid_name
                info += @_property 'Area (ac)', props.acres # TODO: support hectares

                if props.productivity
                    # TODO: only include "Avg" if there was more than one?
                    info += @_property 'Avg Yield', props.productivity

                if props.musym
                    info += @_property 'Soil Type', props.musym

                if props.soil_yield
                    info += @_property 'Soil Yield', props.soil_yield

                is_first_truth_strip = false
                if props.truth_strip
                    if props.real_strip_id
                        strip = _.filter @rxLayer.data.truth_strips, { real_strip_id: props.real_strip_id }
                    else
                        strip = _.filter @rxLayer.data.truth_strips, { strip_id: props.truth_strip_id }

                    # The first truth strip is not editable
                    if strip.length > 0  and strip[0].strip_id is 0
                        info += @_property 'Population', props.population
                        is_first_truth_strip = true

                if not is_first_truth_strip
                    info += @_property 'Population',
                    "<input class='population' type='text' value='#{props.population}' />"

                if props.truth_strip
                    info += @_property 'Truth Strip', ''

                if props.irrigated and props.irrigated not in ['false', 'Dryland']
                    info += @_property 'Irrigated', ''

                info += '</table>'

                if not is_first_truth_strip
                    info += "
                        <div class='pull-right btn btn-primary'>
                            <i class='fa fa-check'> </i> Save
                        </div>
                        <div class='clearfix'></div>
                    "
                info += '</div>'

            elem = $(info)
            layer.bindPopup(elem[0]).openPopup(e.latlng)
            elem.find('.btn').on 'click', () =>
                val = parseInt(elem.find('.population').val())
                return if not val
                @rxLayer.setPopulation(props, val)

                # Want to see a magic trick? Comment out the following line,
                # then test this. Change a population, click Save, and voilá!
                # The popup will still go away!
                layer.closePopup()

                # (Spoiler: This is actually because $apply() triggers a $watch
                # that calls recolor(), which calls makeMapLayer(), which
                # re-creates the map layer, thereby wiping out any popups for
                # the old layer. So not *actually* magic, but pretty close!)
                # Of course, we want to always close the popup, even if the pop
                # hasn't changed, so we can't rely on the $watch to close it.

                @rootScope.$apply()

    _property: (key, val) =>
        return "<tr>
            <td><strong>#{key}</strong></td>
            <td>#{val}</td>
        </tr>"
